import React, { createContext, useContext, useEffect, useState } from "react";
import { getDataAuth } from "../apiService";
import { useNavigate } from "react-router-dom";
import { toggleWishlistApi } from "../utility/wishlistService";
import { useWishlist } from "./WishlistContext";
import safeStorage from '../utility/safeStorage';

// Create context
const AuthContext = createContext();

// Export context hook / // Hook to use context
export const useAuth = () => useContext(AuthContext);

// AuthProvider component
export function AuthProvider({ children }) {

  const [reviewCount, setReviewCount] = useState(0);
  const [ratingCount, setRatingCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const { updateWishlist } = useWishlist();
  const { resetWishlist } = useWishlist();

  useEffect(() => {
    // ✅ Small delay for mobile storage read
    const timer = setTimeout(() => {
      const storedUser = safeStorage.getItem("userData");
      const refreshToken = safeStorage.getItem("refreshToken");
      const token = safeStorage.getItem("accessToken");

      if (!token || token === "undefined" || token === "null" || !storedUser) {
        setIsLoggedIn(false);
        setUserData(null);
        return;
      }

      try {
        const parsedUser = JSON.parse(storedUser);
        setIsLoggedIn(true);
        setUserData(parsedUser);
        fetchReviewData();
      } catch {
        setIsLoggedIn(false);
        setUserData(null);
      }
    }, 50); // ✅ 50ms is enough for mobile
    return () => clearTimeout(timer);
  }, []);

  const fetchReviewData = async (token) => {
    try {
      const token = safeStorage.getItem('accessToken');
      const response = await getDataAuth("BookReview/GetUserInfoByLogInId", null, navigate, token);
      console.log("fetchReviewData:", response)
      setReviewCount(response.reviewCount || 0);
      setRatingCount(response.ratingCount || 0);
    } catch (err) {
      setReviewCount(0);
      setRatingCount(0);
    }
  };

  const login = async (response, redirectData) => {   //its called from Login Page
    if (!response?.success) {
      switch (response?.errorCode) {

        case "USER_NOT_FOUND":
          navigate("/Login");
          break;

        case "ACCOUNT_INACTIVE":
          navigate("/Login");
          break;

        case "ACCOUNT_LOCKED":
          navigate("/account-locked");
          break;

        case "USER_LOGIN_ATTEMPT":
          navigate("/Login");
          break;

        case "ACCOUNT_DELETED":
          navigate("/contact-support");
          break;

        // default:
        //   toast.error(response?.message || "Login failed");
      }
      return;
    }

    if ((response?.success === true || response?.data?.success === true) && response?.data) {

      const { userId, accessToken, refreshToken, name, userName } = response.data;

      //   document.body.insertAdjacentHTML('afterbegin', `
      //   <div style="position:fixed;top:0;left:0;right:0;background:red;color:white;
      //               padding:10px;z-index:99999;font-size:12px;word-break:break-all">
      //     TOKEN: ${accessToken} <br/>
      //     TYPE: ${typeof accessToken} <br/>
      //     KEYS: ${Object.keys(response.data).join(', ')}
      //   </div>
      // `);
      //   return;
      //alert(`AuthContext Page response.data: ${response.data.userName}`);

      safeStorage.setItem("userId", userId);
      safeStorage.setItem("refreshToken", refreshToken);
      safeStorage.setItem("accessToken", accessToken);

      const user = { userId, name: name || "", userName: userName || "" };
      safeStorage.setItem("userData", JSON.stringify(user));
      setUserData(user);
      setIsLoggedIn(true);

      const token = safeStorage.getItem('accessToken');

      if (token && token !== "null" && token !== "undefined") {
        fetchReviewData(token); // ✅ only call after token confirmed saved
      }
      // ✅ Small delay — gives mobile browser time to write storage
      await new Promise(resolve => setTimeout(resolve, 100));

      const pending = safeStorage.getItem("pendingAction");

      //console.log("pending status:", pending)
      if (pending) {
        try {
          const action = JSON.parse(pending);
          const returnUrl = safeStorage.getItem("returnUrl") || "/";
          safeStorage.removeItem("returnUrl");
          if (returnUrl) {
            if (action.type === "RATE_BOOK") {
              navigate(returnUrl, {
                state: { pendingRatingAction: action },
                replace: true,
              });

              safeStorage.removeItem("pendingAction");
              return;
            }

            if (action.type === "WISH_LIST") {
              const res = await toggleWishlistApi(action.bookId, navigate);
              updateWishlist(action.bookId, { count: res.wishlistCount, isWishlisted: res.isWishlisted });
              safeStorage.removeItem("pendingAction");
              navigate(returnUrl, { replace: true });
              return;
            }

          } else {
            navigate("/", { replace: true });
          }
        } catch (e) {
          safeStorage.removeItem("pendingAction");
        }
      }

      const returnUrl = safeStorage.getItem("returnUrl") || "/";

      if (returnUrl === "/changePassword") {
        safeStorage.removeItem("returnUrl");
        navigate("/", { replace: true });
        return;
      }
      safeStorage.removeItem("returnUrl");
      const from = redirectData.from || returnUrl;
      const tab = redirectData.tab;

      navigate(from, {
        replace: true,
        state: { tab }   // 👈 pass tab forward
      });

      // safeStorage.removeItem("returnUrl");
      // console.log("Return Status:", returnUrl)
      // navigate(returnUrl, { replace: true });
    }
  };

  const logout = async () => {

    const refreshToken = safeStorage.getItem("refreshToken");

    try {
      await postData("/auth/Logout", { refreshToken });
    } catch (err) {
      //console.log("Logout API failed");
    }
    safeStorage.removeItem("refreshToken");
    safeStorage.removeItem("accessToken");
    safeStorage.removeItem("userId");
    safeStorage.removeItem("userData");
    safeStorage.removeItem("returnUrl");
    setUserData(null);
    setIsLoggedIn(false);
    setReviewCount(0);
    setRatingCount(0);
    resetWishlist();
    navigate("/");
  };

  const logoutAll = async () => {
    try {
      await logoutAllApi();
    } catch (err) { }

    logout(); // reuse cleanup
  };

  return (
    <AuthContext.Provider
      value={{ userData, isLoggedIn, login, logout, reviewCount, ratingCount }}
    >
      {children}
    </AuthContext.Provider>
  );
}
